export type FormulaErrorCode =
  | 'SYNTAX'
  | 'UNKNOWN_FUNCTION'
  | 'ARITY'
  | 'UNKNOWN_IDENTIFIER'
  | 'MISSING_DATA'
  | 'DIMENSION'
  | 'UNIT'
  | 'DIVISION_BY_ZERO'
  | 'DOMAIN'
  | 'TOO_COMPLEX';

/** Erreur de formule localisée (position dans le texte source) et explicable à l'utilisateur. */
export class FormulaError extends Error {
  constructor(
    public readonly code: FormulaErrorCode,
    message: string,
    public readonly position?: number,
    public readonly details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'FormulaError';
  }
}

/** Message normalisé demandé par le cahier des charges (§49). */
export const MISSING_DATA_MESSAGE =
  'Donnée non disponible — veuillez la renseigner ou choisir une valeur de référence.';
